export default __webpack_public_path__ + "static/media/suggestion-chips-dialog2.ef365fa2.png";